// Cities enum mapping from backend
export const CITIES_ENUM = {
  // Salt Lake County
  SALT_LAKE_CITY: "Salt Lake City",
  WEST_VALLEY_CITY: "West Valley City",
  WEST_JORDAN: "West Jordan",
  SANDY: "Sandy",
  TAYLORSVILLE: "Taylorsville",
  SOUTH_JORDAN: "South Jordan",
  MURRAY: "Murray",
  MIDVALE: "Midvale",
  MILLCREEK: "Millcreek",
  COTTONWOOD_HEIGHTS: "Cottonwood Heights",
  DRAPER: "Draper",
  HOLLADAY: "Holladay",
  HERRIMAN: "Herriman",
  RIVERTON: "Riverton",
  SOUTH_SALT_LAKE: "South Salt Lake",
  KEARNS: "Kearns",
  MAGNA: "Magna",
  BLUFFDALE: "Bluffdale",

  // Utah County
  PROVO: "Provo",
  OREM: "Orem",
  SPANISH_FORK: "Spanish Fork",
  SPRINGVILLE: "Springville",
  PLEASANT_GROVE: "Pleasant Grove",
  AMERICAN_FORK: "American Fork",
  LEHI: "Lehi",
  PAYSON: "Payson",
  SARATOGA_SPRINGS: "Saratoga Springs",
  EAGLE_MOUNTAIN: "Eagle Mountain",
  LINDON: "Lindon",
  HIGHLAND: "Highland",
  ALPINE: "Alpine",
  CEDAR_HILLS: "Cedar Hills",
  VINEYARD: "Vineyard",
  MAPLETON: "Mapleton",
  SALEM: "Salem",
  SANTAQUIN: "Santaquin",
  GENOLA: "Genola",
  GOSHEN: "Goshen",

  // Davis County
  LAYTON: "Layton",
  CLEARFIELD: "Clearfield",
  KAYSVILLE: "Kaysville",
  SYRACUSE: "Syracuse",
  CLINTON: "Clinton",
  BOUNTIFUL: "Bountiful",
  FARMINGTON: "Farmington",
  CENTERVILLE: "Centerville",
  WEST_POINT: "West Point",
  NORTH_SALT_LAKE: "North Salt Lake",
  WOODS_CROSS: "Woods Cross",
  FRUIT_HEIGHTS: "Fruit Heights",
  SOUTH_WEBER: "South Weber",

  // Cache County
  LOGAN: "Logan",
  SMITHFIELD: "Smithfield",
  NORTH_LOGAN: "North Logan",
  PROVIDENCE: "Providence",
  RIVER_HEIGHTS: "River Heights",
  HYDE_PARK: "Hyde Park",
  MILLVILLE: "Millville",
  NIBLEY: "Nibley",
  WELLSVILLE: "Wellsville",
  MENDON: "Mendon",
  CORNISH: "Cornish",
  TRENTON: "Trenton",
  LEWISTON: "Lewiston",
  RICHMOND: "Richmond",
  CLARKSTON: "Clarkston",
  NEWTON: "Newton",

  // Weber County
  OGDEN: "Ogden",
  ROY: "Roy",
  RIVERDALE: "Riverdale",
  WASHINGTON_TERRACE: "Washington Terrace",
  SOUTH_OGDEN: "South Ogden",
  NORTH_OGDEN: "North Ogden",
  PLEASANT_VIEW: "Pleasant View",
  FARR_WEST: "Farr West",
  WEST_HAVEN: "West Haven",
  MARRIOTT_SLATERVILLE: "Marriott Slaterville",
  UINTAH: "Uintah",
  HOOPER: "Hooper",
  PLAIN_CITY: "Plain City",
  HUNTSVILLE: "Huntsville",
  EDEN: "Eden",
  LIBERTY: "Liberty",

  // Box Elder County
  BRIGHAM_CITY: "Brigham City",
  TREMONTON: "Tremonton",
  GARLAND: "Garland",
  PERRY: "Perry",
  WILLARD: "Willard",
  BEAR_RIVER_CITY: "Bear River City",
  CORINNE: "Corinne",
  DEWEYVILLE: "Deweyville",
  ELWOOD: "Elwood",
  FIELDING: "Fielding",
  HONEYVILLE: "Honeyville",
  MANTUA: "Mantua",
  PLYMOUTH: "Plymouth",

  // Tooele County
  TOOELE: "Tooele",
  GRANTSVILLE: "Grantsville",
  WENDOVER: "Wendover",
  STOCKTON: "Stockton",
  RUSH_VALLEY: "Rush Valley",
  OPHIR: "Ophir",
  VERNON: "Vernon",
  LAKE_POINT: "Lake Point",
} as const;

export type CityEnum = keyof typeof CITIES_ENUM;

// County groupings
export const COUNTY_CITY_GROUPS = {
  "Salt Lake County": [
    "SALT_LAKE_CITY",
    "WEST_VALLEY_CITY",
    "WEST_JORDAN",
    "SANDY",
    "TAYLORSVILLE",
    "SOUTH_JORDAN",
    "MURRAY",
    "MIDVALE",
    "MILLCREEK",
    "COTTONWOOD_HEIGHTS",
    "DRAPER",
    "HOLLADAY",
    "HERRIMAN",
    "RIVERTON",
    "SOUTH_SALT_LAKE",
    "KEARNS",
    "MAGNA",
    "BLUFFDALE",
  ],
  "Utah County": [
    "PROVO",
    "OREM",
    "SPANISH_FORK",
    "SPRINGVILLE",
    "PLEASANT_GROVE",
    "AMERICAN_FORK",
    "LEHI",
    "PAYSON",
    "SARATOGA_SPRINGS",
    "EAGLE_MOUNTAIN",
    "LINDON",
    "HIGHLAND",
    "ALPINE",
    "CEDAR_HILLS",
    "VINEYARD",
    "MAPLETON",
    "SALEM",
    "SANTAQUIN",
    "GENOLA",
    "GOSHEN",
  ],
  "Davis County": [
    "LAYTON",
    "CLEARFIELD",
    "KAYSVILLE",
    "SYRACUSE",
    "CLINTON",
    "BOUNTIFUL",
    "FARMINGTON",
    "CENTERVILLE",
    "WEST_POINT",
    "NORTH_SALT_LAKE",
    "WOODS_CROSS",
    "FRUIT_HEIGHTS",
    "SOUTH_WEBER",
  ],
  "Cache County": [
    "LOGAN",
    "SMITHFIELD",
    "NORTH_LOGAN",
    "PROVIDENCE",
    "RIVER_HEIGHTS",
    "HYDE_PARK",
    "MILLVILLE",
    "NIBLEY",
    "WELLSVILLE",
    "MENDON",
    "CORNISH",
    "TRENTON",
    "LEWISTON",
    "RICHMOND",
    "CLARKSTON",
    "NEWTON",
  ],
  "Weber County": [
    "OGDEN",
    "ROY",
    "RIVERDALE",
    "WASHINGTON_TERRACE",
    "SOUTH_OGDEN",
    "NORTH_OGDEN",
    "PLEASANT_VIEW",
    "FARR_WEST",
    "WEST_HAVEN",
    "MARRIOTT_SLATERVILLE",
    "UINTAH",
    "HOOPER",
    "PLAIN_CITY",
    "HUNTSVILLE",
    "EDEN",
    "LIBERTY",
  ],
  "Box Elder County": [
    "BRIGHAM_CITY",
    "TREMONTON",
    "GARLAND",
    "PERRY",
    "WILLARD",
    "BEAR_RIVER_CITY",
    "CORINNE",
    "DEWEYVILLE",
    "ELWOOD",
    "FIELDING",
    "HONEYVILLE",
    "MANTUA",
    "PLYMOUTH",
  ],
  "Tooele County": [
    "TOOELE",
    "GRANTSVILLE",
    "WENDOVER",
    "STOCKTON",
    "RUSH_VALLEY",
    "OPHIR",
    "VERNON",
    "LAKE_POINT",
  ],
} as const;

// Get array of cities for dropdown options
export const getCityOptions = () => {
  return Object.entries(CITIES_ENUM).map(([value, label]) => ({
    value,
    label,
  }));
};

// Get display label for a city enum value
export const getCityLabel = (cityEnum: CityEnum): string => {
  return CITIES_ENUM[cityEnum] || cityEnum;
};

// Get cities grouped by county with their labels
export const getCitiesByCounty = () => {
  return Object.entries(COUNTY_CITY_GROUPS).map(([county, cities]) => ({
    county,
    cities: cities.map((cityEnum) => ({
      value: cityEnum,
      label: CITIES_ENUM[cityEnum as CityEnum],
    })),
  }));
};
